import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { getActiveTrainingSlug } from "#/lib/training";

// "/" has no page of its own for now: it sends visitors to the training being
// sold right now (see getActiveTrainingSlug). The "Carte Entrepreneur 101"
// home (src/components/home/entrepreneur-101-page.tsx, with getHomeTrainingSlugs
// in src/lib/home.ts) is hidden rather than deleted — rendering it here again is
// all it takes to bring it back. Cosmetic subdomains (e.g.
// creation-entreprise.moustachir.dz) are still plain host redirects at the
// Traefik layer — no app code involved.
export const Route = createFileRoute("/")({
	beforeLoad: async () => {
		const slug = await getActiveTrainingSlug();
		if (!slug) throw notFound();
		// A temporary redirect (307): which training is current changes over
		// time, so browsers and crawlers must not cache it.
		throw redirect({ to: "/training/$slug", params: { slug } });
	},
});
